import { Stack } from 'expo-router';

import { AuthGate } from '@/components/AuthGate';

const OnboardingLayout = () => (
  <AuthGate>
    <Stack screenOptions={{ headerShown: false }} />
  </AuthGate>
);

export default OnboardingLayout;
